<template>
  <v-container fluid>
    <v-layout justify-start>
      <v-card width="80vw" >
        <v-flex lg12 pa-5 >
          <v-layout>
            <h2 class="primary--text text-uppercase textoAjustado text-center" pa-3>
              {{!sociedadSelectedId ? localization.create.title : localization.create.edit + ' ' + sociedadNombre }}
            </h2>
          </v-layout>
          <v-divider class="divider_subtitle"></v-divider>

          <v-form v-model="valid" id="valid" ref="formSociedades" autocomplete="off">  
            <v-layout wrap align-center justify-start  mb-10>
              <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
                <v-text-field 
                  v-model="codigo" id="codigo"
                  :label="localization.create.codigo"
                  :rules="[rules.obligatorio, rules.max(50)]"
                  maxlength="51"
                />
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
                <v-text-field 
                  v-model="nombre" id="nombre"
                  :rules="[rules.obligatorio, rules.max(100)]" 
                  :label="localization.create.descripcion"
                  maxlength="151"
                />
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
                <v-text-field
                  v-model="nif" id="nif" 
                  :label="localization.create.nif"
                 maxlength="51"
                 :rules="[rules.max(50)]"
                />
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout>
            <v-layout>
            <v-flex >
              <h2 class="primary--text text-uppercase">
                {{localization.list.title}}
              </h2>
            </v-flex>
          </v-layout>
          <v-layout wrap align-center justify-end pb-4>
            <v-flex xs8 sm8 md8 lg8 justify-end class="text-end">
              <v-btn
                style="margin-right: 10px"
                color="primary" 
                @click="dialogImportar = true"
                v-if="tubos"
              >
                IMPORTAR
              </v-btn>
              <v-btn
              style="margin-right: 10px"
              color="primary" 
              :disabled="!codigo || !nombre || sociedadSelectedId ? true : false"
              @click="addSociedad()"
              >
                {{localization.create.addButton}}
              </v-btn>
              <v-btn
                color="primary" 
                :disabled="!sociedadSelectedId "
                @click="updateSociedad()"
              >
                {{localization.create.editarButton}}
              </v-btn>        
            </v-flex>
          </v-layout>
          </v-layout>
            <v-layout wrap justify-end>
              <v-flex xs4 sm4 md4 lg4 mb-4 mt-n4>
                <v-text-field
                  v-model="search" id="search"
                  append-icon="mdi-magnify"
                  label="Filtrar"
                  hide-details></v-text-field>
              </v-flex>
            </v-layout>
          <v-divider class="divider_subtitle"></v-divider>
          <v-data-table
            style="display: inline-block !important; width:77.8vw !important"
            :search="search"
            :headers="headers"
            :items="sociedades"
            sort-by="codigo"
            class="elevation-1"
            
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id" @click="selectItem(item)" :style="{'background-color': sociedadSelectedId === item.id ? 'lightgray' : ''}">
                  <td class="text-xs-center">{{ item.code }}</td>
                  <td class="text-xs-center">{{ item.name }}</td>
                  <td class="text-xs-center">{{ item.nif }}</td>
                  <td class="text-xs-center">
                    <v-flex row justify-center>
                      <v-icon class="iconSize" small @click="openDelete(item.id)">delete</v-icon>
                    </v-flex>
                  </td>
                </tr>
              </tbody>
              <ConfirmDialog @close="deleteItem()" :text="textDialog"
                @cancel="dialog = false" :dialogFlag="dialog" />
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
      <FormImportar v-model="dialogImportar" id="dialogImportar" v-if="dialogImportar" :tipo="'sociedades'" @reload="refrescarImportar()" @input="refrescarImportar()"/>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmDialog from '../../custom/confirmDialog'
import rulesMixin from '@/components/generic/rules.js'
import FormImportar from '../../incidencias/formularios/gestion/formImportarSociedades'

export default {
  mixins: [rulesMixin],
  components: {
    ConfirmDialog,
    FormImportar
  },
  data () {
    return {
      tipo: 'sociedades',
      valid: false,
      search: '',
      codigo: null,
      nombre: null,
      nif: null,
      dialog: false,
      itemToDeleteId: null,
      textDialog: null,
      sociedadSelectedId: null,
      dialogImportar: false,
      sociedadNombre: '',
      tubos: true
    }
  },
  computed: {
    ...mapGetters({
      /* tubos: 'getTubos' */
    }),
    headers () {
      return [
        { text: this.localization.list.codigo, value: 'code', sortable: true, align: 'left' },
        { text: this.localization.list.descripcion, value: 'name', sortable: true, align: 'left' },
        { text: this.localization.list.nif, value: 'nif', sortable: true, align: 'left' },
        { text: '', value: '', align: 'center' }
      ]
    },
    localization () {
      return this.$t('gestion.sociedades')
    },
    sociedades(){
      if (this.$store.state.gestion.societies) {
        return this.$store.state.gestion.societies
      }
      return []
    },
    seccion(){
      if(this.$store.state.gestion.componenteSeleccionado){
        return this.$store.state.gestion.componenteSeleccionado
      }
      return ''
    }
  },
  async created(){
    this.loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel
        })
        await this.getSociedades()
    this.loader.hide()
  },
  mounted () {

  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getSociedades: 'gestion/obtenerSociedades',
      addSociety: 'gestion/addSociety',
      editSociety: 'gestion/updateSociety',
      deleteSociety: 'gestion/deleteSocieties',
      getProviders: 'gestion/getProviders',
      getClientes: 'gestion/getClientes',
      getPromotions: 'gestion/getPromotions',
    }),
    async openDelete (id) {
      this.textDialog = '¿Está seguro que desea eliminar el elemento seleccionado?'
      this.openDialog(id)
    },
    selectItem (item) {
      if (!this.sociedadSelectedId || this.sociedadSelectedId !== item.id) {
        this.sociedadSelectedId = item.id
        this.sociedadNombre = item.name
      } else {
        if(!this.dialog){
        this.sociedadSelectedId = null}
      }
    },
    openDialog (itemId) {
      this.dialog = true
      this.itemToDeleteId = itemId
    },
    async deleteItem () {
      this.dialog = false
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
        })
      try{
        await this.deleteSociety(this.itemToDeleteId)
        this.sociedadSelectedId = null
        await this.getSociedades()
        this.resetValues()
        this.addAlert({texto: this.$t('baja_correcta'), color: 'success'})
      } catch(e) {
        this.addAlert({texto: e.message, color: 'error'})
      }
      this.loader.hide()   
    },
    async addSociedad () {
      this.$refs.formSociedades.validate()
      if (!this.valid) {
        this.addAlert({texto: 'Por favor, revise los campos marcados en rojo', color: 'error'})
      } else {
        this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
        })
        try {
          const newSociedad = {
            code: this.codigo,
            name: this.nombre,
            nif: this.nif
          }
          await this.addSociety(newSociedad)
          this.resetValues()
          await this.getSociedades()
          this.loader.hide()
          this.addAlert({texto: this.$t('alta_correcta'), color: 'success'})
        } catch (error) {
          this.loader.hide()
          this.addAlert({texto: error.message, color: 'error'})}
      }
    },
    async updateSociedad () {
      this.$refs.formSociedades.validate()
      if (!this.valid) {
        this.addAlert({texto: 'Por favor, revise los campos marcados en rojo', color: 'error'})
      } else {
        this.loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel
        })
        try {
          const sociedad = {
            id: this.sociedadSelectedId,
            code: this.codigo,
            name: this.nombre,
            nif: this.nif
          }
          await this.editSociety(sociedad)
          await this.getSociedades()
           this.sociedadNombre = this.nombre
          
          this.addAlert({texto: this.$t('edicion_correcta'), color: 'success'})
        } catch (error) {
          this.loader.hide()
          this.addAlert({texto: error.message, color: 'error'})
        }
        this.loader.hide()
        this.getProviders()
        this.getClientes()
        this.getPromotions()
      } 
    },
    resetValues() {
      this.$refs.formSociedades.reset()
      this.codigo = null
      this.nombre = null
      this.nif = null
    },
    async refrescarImportar(){
      await this.getSociedades()
      await this.getProviders()
      await this.getClientes()
      await this.getPromotions()
    }
  },
  watch: {
    sociedadSelectedId () {
      if (this.sociedadSelectedId != null) {
        let sociedad = this.sociedades.find(x => x.id === this.sociedadSelectedId)
        this.codigo = sociedad ? sociedad.code : null
        this.nombre = sociedad ? sociedad.name : null
        this.nif = sociedad ? sociedad.nif : null
      } else {
        this.resetValues()
      }
    },
    seccion (){
      this.resetValues()
      this.sociedadSelectedId = null
      this.search = ''
    }
  }
}
</script>
